export default __webpack_public_path__ + "static/media/fondo-menu-home.476de70d.png";